/**
 * successionScorePlaceholder.constants.js
 *
 * TEMPORARY — static placeholder values for score fields the succession-tree
 * API does not return yet: readiness_score, tenure_months,
 * matches_above_threshold, succession_score. Every card shows the same fixed
 * numbers on purpose — this is a visual placeholder, not a calculation, and
 * intentionally does not vary per employee.
 *
 * Adapter pattern: every consumer reads a field as
 *   selectedEmployee.<field> ?? STATIC_SCORE_PLACEHOLDER.<field>
 * (nullish coalescing, so a real `0` or `false` from the API is never
 * overwritten — only an actually-missing null/undefined field falls back).
 * The day the backend adds any of these fields to the succession-tree
 * response, the real per-employee value is used automatically, with zero
 * changes to SuccessionEmployeeCard.jsx or any other component — delete this
 * file and its `?? STATIC_SCORE_PLACEHOLDER...` call sites once every field
 * is live for every employee.
 */
export const STATIC_SCORE_PLACEHOLDER = {
  readiness_score: 75,
  tenure_months: 24,
  matches_above_threshold: 1,
  succession_score: 70,
};

const PLACEHOLDER_FIELDS = Object.keys(STATIC_SCORE_PLACEHOLDER);

// True when at least one of the fields above is missing from the real API
// payload for this employee — i.e. a placeholder value is showing somewhere
// on the card. Drives the small "Placeholder data" dev/testing indicator so
// these static demo numbers are never mistaken for a real HR assessment.
// Goes to false automatically, field by field, as the backend starts
// returning real values for a given employee — no caller changes needed.
export const hasPlaceholderScores = (employee) =>
  PLACEHOLDER_FIELDS.some((field) => employee?.[field] == null);
